import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';
const StyledButton = styled(MuiButton) `
  margin-left: 12px;
`;
const Button = (props) => {
    return React.createElement(StyledButton, Object.assign({ color: "primary", variant: "contained" }, props));
};
Button.displayName = 'Newsletter.Button';
const ButtonExtra = styled(Button) ``;
export default ButtonExtra;
